import React from 'react';
import {
  StandardInputBaseProps,
  inputContainerStyles,
  labelStyles,
  requiredIndicatorStyles,
  getInputClassName,
} from './StandardInputStyles';

interface Props extends StandardInputBaseProps {
  onChange: React.ChangeEventHandler<HTMLTextAreaElement> | undefined;
  rows?: number;
  disabled?: boolean;
  className?: string;
}

export default function StandardInputTextarea({
  id,
  label,
  isRequired,
  placeholderText,
  value,
  onChange,
  rows = 4,
  disabled = false,
  isLoading = false,
  className,
}: Props) {
  const isDisabled = disabled || isLoading;
  return (
    <div className={inputContainerStyles}>
      <label htmlFor={id} className={labelStyles}>
        {label}
        {isRequired && <span className={requiredIndicatorStyles}>*</span>}
      </label>
      <div className='w-full flex flex-col relative'>
        <textarea
          id={id}
          placeholder={placeholderText ?? ''}
          className={`${getInputClassName('textarea')} ${className ?? ''} ${
            isDisabled ? 'cursor-default pointer-events-none select-none' : ''
          }`}
          rows={rows}
          value={value}
          onChange={onChange}
          readOnly={isDisabled}
          aria-disabled={isDisabled}
          tabIndex={isDisabled ? -1 : 0}
        />
      </div>
    </div>
  );
}
